module.exports = __webpack_public_path__ + "img/review-1.c31fb3a1.png";